declare const __IsLocal__: boolean

export namespace CompileTimeConstants {
  // TODO alkwa add back in __isAutomation__
  export const isLocal = __IsLocal__
}
